import { render, staticRenderFns } from "./GNBMenu.vue?vue&type=template&id=45c2d91b&scoped=true&"
import script from "./GNBMenu.vue?vue&type=script&lang=js&"
export * from "./GNBMenu.vue?vue&type=script&lang=js&"
import style0 from "./GNBMenu.vue?vue&type=style&index=0&id=45c2d91b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2d91b",
  null
  
)

export default component.exports